module.exports = __webpack_public_path__ + "img/activetick.00b2f6bb.svg";